import gql from 'graphql-tag';

import { gql as gqlFn } from '@/graphql/__generated__';

export const projectVersionsQuery = gqlFn(/* GraphQL */ `
  query projectVersions($project: ID!, $limit: Int, $after: String, $before: String) {
    projectVersions(
      project: $project
      orderBy: "DESC"
      first: $limit
      after: $after
      before: $before
    ) {
      totalCount
      edges {
        node {
          ...ProjectVersion
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`);

export const projectVersionCreateMutation = gqlFn(/* GraphQL */ `
  mutation CreateProjectVersion($project: ID!, $name: String!) {
    createVersion(input: { project: $project, name: $name }) {
      version {
        ...ProjectVersion
      }
    }
  }
`);

const projectVersionFragment = gql`
  fragment ProjectVersion on ProjectVersionNode {
    id
    timestamp
    name
    lastChangedBy {
      ...UserSimple
    }
    createdBy {
      ...UserSimple
    }
    newChangesAvailable
  }
`;
